// ─── El visor de documentos DENTRO de la app (celular y app instalada) ───────
// En escritorio cada documento (cotización, orden, factura, certificado) se abre
// en una ventana nueva con su barra de «Descargar PDF / Imprimir». En el
// celular eso no sirve: el iPhone instalado como app bloquea las ventanas
// emergentes o las abre fuera, en Safari, y el usuario "pierde" AURA.
//
// Aquí el mismo HTML se muestra en un iframe a pantalla completa, encima de la
// app, con un botón para cerrar. El iframe es `srcdoc`, es decir, del mismo
// origen: la barra de descarga que viaja dentro del documento funciona igual
// (y en el teléfono ofrece COMPARTIR el PDF en vez de descargarlo, ver
// barraYGenerador en export/pdf.js).
//
// Vive fuera de #root a propósito: render() reconstruye todo el DOM de la app
// y lo barrería.
const ID = "aura-visor-doc";

export function esAppInstalada() {
  try {
    return (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || navigator.standalone === true;
  } catch { return false; }
}

// ¿Conviene mostrar el documento adentro en vez de en una ventana aparte?
export function usarVisorInterno() {
  return window.innerWidth <= 768 || esAppInstalada();
}

// Mientras el visor está abierto, la PESTAÑA lleva el nombre del documento.
// Es el que el navegador del celular propone al guardar, imprimir o compartir
// desde su propio menú: con el de la app, el archivo salía como «AURA».
let tituloApp = null;

export function cerrarVisorDoc() {
  const el = document.getElementById(ID);
  if (el) el.remove();
  document.documentElement.classList.remove("aura-visor-abierto");
  if (tituloApp != null) { document.title = tituloApp; tituloApp = null; }
}

// `fuente` es { html } (documento armado por AURA) o { url } (un adjunto:
// remisión firmada, PDF de Dataico). Devuelve false si no toca abrirlo aquí,
// para que quien llama siga con la ventana de siempre.
export function abrirDocumentoEnApp(titulo, fuente) {
  if (!usarVisorInterno()) return false;
  cerrarVisorDoc();
  const cont = document.createElement("div");
  cont.id = ID;
  cont.style.cssText = `
    position:fixed;inset:0;z-index:2000;display:flex;flex-direction:column;
    background:#0f172a;
  `;
  const cab = document.createElement("div");
  cab.style.cssText = `
    display:flex;align-items:center;gap:10px;flex-shrink:0;
    padding:calc(8px + env(safe-area-inset-top, 0px)) 12px 8px;
    background:#12264D;color:white;font-family:inherit;
  `;
  cab.innerHTML = `
    <button data-visor-cerrar type="button" style="background:rgba(255,255,255,.12);color:white;border:none;border-radius:8px;padding:8px 12px;font-size:14px;font-weight:700;cursor:pointer;">✕ Cerrar</button>
    <div style="flex:1;min-width:0;font-size:12.5px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"></div>
  `;
  cab.querySelector("div").textContent = titulo || "Documento";
  cab.querySelector("[data-visor-cerrar]").onclick = cerrarVisorDoc;
  const marco = document.createElement("iframe");
  marco.name = ID;
  marco.title = titulo || "Documento";
  // Compartir el PDF ocurre DENTRO del marco: se le concede explícitamente.
  marco.setAttribute("allow", "web-share; clipboard-write");
  marco.style.cssText = "flex:1;width:100%;border:0;background:white;";
  if (fuente && fuente.url) marco.src = fuente.url;
  else marco.srcdoc = (fuente && fuente.html) || "";
  cont.appendChild(cab);
  cont.appendChild(marco);
  document.body.appendChild(cont);
  document.documentElement.classList.add("aura-visor-abierto");
  if (titulo) { tituloApp = document.title; document.title = titulo; }
  return true;
}
